export { default as mapAction } from "./mapAction";
